import { gql } from '@apollo/client';

// Common fragment to avoid repetition
export const OPERATING_HOURS_FIELDS = gql`
  fragment OperatingHoursFields on OperatingHours {
    id
    locationId
    PickupLocationType
    sundayAvailable
    sundayAlwaysAvailable
    sundayStart
    sundayEnd
    mondayAvailable
    mondayAlwaysAvailable
    mondayStart
    mondayEnd
    tuesdayAvailable
    tuesdayAlwaysAvailable
    tuesdayStart
    tuesdayEnd
    wednesdayAvailable
    wednesdayAlwaysAvailable
    wednesdayStart
    wednesdayEnd
    thursdayAvailable
    thursdayAlwaysAvailable
    thursdayStart
    thursdayEnd
    fridayAvailable
    fridayAlwaysAvailable
    fridayStart
    fridayEnd
    saturdayAvailable
    saturdayAlwaysAvailable
    saturdayStart
    saturdayEnd
    alwaysAvailable
    location {
      id
      name
    }
    createdAt
    updatedAt
  }
`;

// Queries
export const GET_ALL_OPERATING_HOURS = gql`
  ${OPERATING_HOURS_FIELDS}
  query GetAllOperatingHours {
    operatingHours {
      ...OperatingHoursFields
    }
  }
`;

export const GET_OPERATING_HOUR = gql`
  ${OPERATING_HOURS_FIELDS}
  query GetOperatingHour($id: ID!) {
    operatingHour(id: $id) {
      ...OperatingHoursFields
    }
  }
`;

export const GET_OPERATING_HOURS_BY_LOCATION = gql`
  query OperatingHoursByLocationAndType(
    $locationId: Int!
    $PickupLocationType: PickupLocationType!
  ) {
    operatingHoursByLocationAndType(
      locationId: $locationId
      PickupLocationType: $PickupLocationType
    ) {
      id
      locationId
      PickupLocationType
      alwaysAvailable
      sundayAvailable
      sundayAlwaysAvailable
      sundayStart
      sundayEnd
      mondayAvailable
      mondayAlwaysAvailable
      mondayStart
      mondayEnd
      tuesdayAvailable
      tuesdayAlwaysAvailable
      tuesdayStart
      tuesdayEnd
      wednesdayAvailable
      wednesdayAlwaysAvailable
      wednesdayStart
      wednesdayEnd
      thursdayAvailable
      thursdayAlwaysAvailable
      thursdayStart
      thursdayEnd
      fridayAvailable
      fridayAlwaysAvailable
      fridayStart
      fridayEnd
      saturdayAvailable
      saturdayAlwaysAvailable
      saturdayStart
      saturdayEnd
      createdAt
      updatedAt
    }
  }
`;

export const GET_OPERATING_HOURS_BY_LOCATION_AND_TYPE = gql`
  ${OPERATING_HOURS_FIELDS}
  query GetOperatingHoursByLocationAndType(
    $locationId: Int!
    $PickupLocationType: PickupLocationType!
  ) {
    operatingHoursByLocationAndType(
      locationId: $locationId
      PickupLocationType: $PickupLocationType
    ) {
      ...OperatingHoursFields
    }
  }
`;

export const CHECK_AVAILABILITY = gql`
  query CheckAvailability(
    $locationId: Int!
    $PickupLocationType: PickupLocationType!
    $date: DateTime!
  ) {
    checkAvailability(locationId: $locationId, PickupLocationType: $PickupLocationType, date: $date)
  }
`;

// Mutations
export const CREATE_OPERATING_HOURS = gql`
  mutation CreateOperatingHours($createOperatingHoursInput: CreateOperatingHoursInput!) {
    createOperatingHours(createOperatingHoursInput: $createOperatingHoursInput) {
      id
      locationId
      PickupLocationType
      alwaysAvailable
      sundayAvailable
      sundayAlwaysAvailable
      sundayStart
      sundayEnd
      mondayAvailable
      mondayAlwaysAvailable
      mondayStart
      mondayEnd
      tuesdayAvailable
      tuesdayAlwaysAvailable
      tuesdayStart
      tuesdayEnd
      wednesdayAvailable
      wednesdayAlwaysAvailable
      wednesdayStart
      wednesdayEnd
      thursdayAvailable
      thursdayAlwaysAvailable
      thursdayStart
      thursdayEnd
      fridayAvailable
      fridayAlwaysAvailable
      fridayStart
      fridayEnd
      saturdayAvailable
      saturdayAlwaysAvailable
      saturdayStart
      saturdayEnd
    }
  }
`;

export const UPDATE_OPERATING_HOURS = gql`
  mutation UpdateOperatingHours($updateOperatingHoursInput: UpdateOperatingHoursInput!) {
    updateOperatingHours(updateOperatingHoursInput: $updateOperatingHoursInput) {
      id
      locationId
      PickupLocationType
      alwaysAvailable
      sundayAvailable
      sundayAlwaysAvailable
      sundayStart
      sundayEnd
      mondayAvailable
      mondayAlwaysAvailable
      mondayStart
      mondayEnd
      tuesdayAvailable
      tuesdayAlwaysAvailable
      tuesdayStart
      tuesdayEnd
      wednesdayAvailable
      wednesdayAlwaysAvailable
      wednesdayStart
      wednesdayEnd
      thursdayAvailable
      thursdayAlwaysAvailable
      thursdayStart
      thursdayEnd
      fridayAvailable
      fridayAlwaysAvailable
      fridayStart
      fridayEnd
      saturdayAvailable
      saturdayAlwaysAvailable
      saturdayStart
      saturdayEnd
    }
  }
`;

export const DELETE_OPERATING_HOURS = gql`
  mutation RemoveOperatingHours($id: ID!) {
    removeOperatingHours(id: $id)
  }
`;
